import * as Yup from "yup";

export const reportFormSchema = Yup.object().shape({
  name: Yup.string().required("Report name is required"),
  description: Yup.string().nullable(),
  type: Yup.string().required("Select a report type"),
  format: Yup.string().required("Select a format"),
  dateRangeStart: Yup.string().required("Start date is required"),
  dateRangeEnd: Yup.string().required("End date is required"),
  note: Yup.string().nullable(),
});

export const reportApprovalSchema = Yup.object().shape({
  note: Yup.string().nullable(),
});
